// Normalize free-form fitment times (SA style "08H00", typos like "10;00", "8h30",
// "8:5", "0900") into the canonical "HH:MM" that <input type="time"> requires.
// Returns "" if nothing usable can be parsed.
export const normalizeTime = (raw) => {
  if (raw == null) return "";
  const s = String(raw).trim();
  if (!s) return "";
  // Grab up to two number groups
  const m = s.match(/(\d{1,2})[^0-9]*(\d{1,2})?/);
  if (!m) return "";
  let hh = parseInt(m[1], 10);
  let mm = m[2] != null ? parseInt(m[2], 10) : 0;
  if (Number.isNaN(hh) || Number.isNaN(mm)) return "";
  if (hh < 0 || hh > 23) return "";
  if (mm < 0 || mm > 59) return "";
  return `${String(hh).padStart(2, "0")}:${String(mm).padStart(2, "0")}`;
};
